/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-22 13:12:16
 * @LastEditors: 陈钊贤
 * @Description: 接口文档
 * @LastEditTime: 2021-05-28 15:11:39
 */
import { request } from "./api-require";
const API_URL = "/basic-system/v1";
//登录
export const sysLogin = (data = {}, config = {}) => {
    return request(API_URL + "/auth/login", data, config);
};
//退出登录
export const sysLoginOut = (data = {}, config = {}) => {
    return request(API_URL + "/auth/logout", data, config);
};
//获取字典大类信息列表
export const getDictTypeList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/dict/type/list", data, config);
};
//获取字典大类信息列表---分页
export const getDictTypeListPage = (data = {}, config = {}) => {
    return request(API_URL + "/dict/type/page", data, config);
};
//新增字典大类
export const addDictType = (data = {}, config = {}) => {
    return request(API_URL + "/dict/type/add", data, config);
};
//修改字典大类
export const upDictType = (data = {}, config = {}) => {
    return request(API_URL + "/dict/type/upd", data, config);
};
//删除字典大类
export const delDictType = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/dict/item/delete", data, config);
};
//根据字典小类pkid的操作排序
export const sortDictType = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/dict/item/sort", data, config);
};
//获取字典信息指定大类下小类列表
export const getDictItemAll = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/dict/item/list", data, config);
};
//分页获取字典信息指定大类下小类列表
export const getDictItemList = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/dict/item/page", data, config);
};
//批量获取多个字典信息大类下小类列表集合
export const getDictItemAllList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/dict/item/list_batch", data, config);
};
//修改字典小类
export const upDictItem = (data = {}, config = {}) => {
    return request(API_URL + "/dict/item/upd", data, config);
};
//新增字典小类
export const addDictItem = (data = {}, config = {}) => {
    return request(API_URL + "/dict/item/add", data, config);
};
//删除字典小类
export const delDictItem = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/dict/item/del", data, config);
};
//在线用户
export const getOnlineuser = (data = {}, config = {}) => {
    return request(API_URL + "/online_user/page", data, config);
};
//强制下线
export const outUser = (data = {}, config = {}) => {
    return request(API_URL + "/online_user/offline", data, config);
};
//上传图片
export const uploadImage = (data = {}, config = {}) => {
    return request(API_URL + "/file/upload_image", data, config);
};
//上传文件
export const uploadFile = (data = {}, config = {}) => {
    return request(API_URL + "/file/upload", data, config);
};
//删除文件
export const deleteFile = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/file/delete", data, config);
};
//下载文件
export const downloadFile = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/file/download", data, config);
};
// 获取运营商
export const getSearchInitData = (data = {}, config = {}) => {
    return request(API_URL + "/alarm/searchInitData", data, config);
};
//查看所有运营商列表
export const getAllOperList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/opr/list", data, config);
};
// 通过运营商获取充电桩
export const getStationByOpr = (data = {}, config = {}) => {
    return request(API_URL + "/alarm/getStationByOpr", data, config);
};
//获取省市区
export const getFindAreaList = (data = {}, config = {}) => {
    return request(API_URL + "/region/findAreaList", data, config);
};
//发送短信验证码
export const getCodeSms = (data = {}, config = {}) => {
    return request(API_URL + "/vercode/sms_test", data, config);
};
//重置密码
export const resetPwd = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/reset_pwd", data, config);
};
//用户
//查询所有运营商自定义角色列表
export const getAllRole = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/role/all", data, config);
};
//分页查询运营商自定义角色列表
export const getRoleList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/role/page", data, config);
};
//保存角色
export const saveRole = (data = {}, config = {}) => {
    return request(API_URL + "/role/save", data, config);
};
//删除角色
export const delRole = (data = {}, config = {}) => {
    return request(API_URL + "/role/delete", data, config);
};
//保存接口权限
export const saveInterfacePermission = (data = {}, config = {}) => {
    return request(API_URL + "/role/save_interface_permission", data, config);
};
//菜单权限列表
export const getPermission = (data = {}, config = {}) => {
    return request(API_URL + "/role/permission", data, config);
};
//查询菜单接口权限列表
export const getInterfacePermission = (data = {}, config = {}) => {
    return request(API_URL + "/role/query_interface_permission", data, config);
};
//获取角色功能菜单权限
export const getrRolePermission = (data = {}, config = {}) => {
    return request(API_URL + "/user/role_permission", data, config);
};
//根据不同用户角色类型 及 所属系统 查询角色列表
export const getRoleSelect = (data = {}, config = {}) => {
    return request(API_URL + "/role/select", data, config);
};
//根据userid 获取角色
export const getUserRole = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/role/select", data, config);
};
//获取角色详情
export const getRoleDetails = (data = {}, config = {}) => {
    return request(API_URL + "/role/selectOne", data, config);
};
//保存角色权限
export const setPermission = (data = {}, config = {}) => {
    return request(API_URL + "/role/set_permission", data, config);
};
//查询设备型号列表
export const getModelList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/model/list", data, config);
};
//分页获取充电桩信息
export const getDeviceOprPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/page", data, config);
};
//添加充电桩
export const getDeviceOprAdd = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/add", data, config);
};
//获取充电桩详情
export const getDeviceOprDetail = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/opr/detail", data, config);
};
//修改充电桩
export const getDeviceOprUpd = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/upd", data, config);
};
//修改充电桩
export const updateDeviceOprStatus = (data = {}, config = {}) => {
    // config.method = "getDel";
    config.method = "postStr";
    return request(API_URL + "/sys/device/opr/upd_device_status", data, config);
};
//迁出充电站
export const quitStation = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/quit_station", data, config);
};
// 获取警告查询
export const getAlarmQuery = (data = {}, config = {}) => {
    return request(API_URL + "/alarm/query", data, config);
};
// 告警分页查询
export const getAlarmPage = (data = {}, config = {}) => {
    return request(API_URL + "/alarm/page", data, config);
};
// 获取警告详情
export const getAlarmOrderDetail = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/alarm/queryOrderDetail", data, config);
};
//设备厂商--分页获取
export const getManufacturerPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/manufacturer/page", data, config);
};
//设备厂商--新增
export const addManufacturer = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/manufacturer/add", data, config);
};
//设备厂商--修改
export const updManufacturer = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/manufacturer/upd", data, config);
};
//设备厂商--删除
export const delManufacturer = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/manufacturer/del", data, config);
};
//获取用户列表
export const getUserList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/user/page", data, config);
};
//修改用户
export const updDataUser = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/upd", data, config);
};
//新增用户
export const addUser = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/add", data, config);
};
//删除用户
export const deleteUser = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/opr/user/del", data, config);
};
//删除用户
export const getOprRoleAll = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/role/all", data, config);
};
//分页查询运营商自定义角色列表
export const getOprRolePage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/role/page", data, config);
};
//新增/修改角色和权限
export const getOprRoleSave = (data = {}, config = {}) => {
    return request(API_URL + "/opr/role/save", data, config);
};
//分页查询运营商自定义角色列表
export const getOprRoleDel = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/opr/role/del", data, config);
};
//分页查询运营商自定义角色列表
export const getOprRolePermission = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/role/permission", data, config);
};
//发送短信验证码
export const vercodeSms = (data = {}, config = {}) => {
    return request(API_URL + "/vercode/sms", data, config);
};
//发送短信验证码测试
export const vercodeSmsTest = (data = {}, config = {}) => {
    return request(API_URL + "/vercode/sms_test", data, config);
};
//校验短信验证码
export const vercodeSmsValidate = (data = {}, config = {}) => {
    return request(API_URL + "/vercode/sms/validate", data, config);
};
//修改密码--重置密码
export const forgetResetPwd = (data = {}, config = {}) => {
    return request(API_URL + "/auth/forget_reset_pwd", data, config);
};
//系统更新日志
export const systemUpdateLog = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/system_update/page", data, config);
};
// /basic-system/system_update/base-upgrade-log/page
// /alarm/count
export const alarmCount = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/summary", data, config);
};
//告警概要总值
export const alarmSummary = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/summary", data, config);
};
//告警概要trend
export const alarmTrend = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/trend", data, config);
};
//告警概要充电站top5
export const alarmStationTop5 = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/station/top5", data, config);
};
//告警概要设备top5
export const alarmChargeTop5 = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/charge/top5", data, config);
};
// 分页获取设备型号列表
export const getModelListPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/model/page", data, config);
};
// 新增设备型号
export const addModelNew = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/model/add", data, config);
};
// 删除设备型号
export const delOneModel = (data = {}, config = {}) => {
    config.method = "del";
    return request(API_URL + "/sys/device/model/del_batch", data, config);
};
// 修改设备型号
export const updModelNew = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/model/upd", data, config);
};
// 分页获取设备清单
export const getDevicePageList = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/page", data, config);
};
// 获取设备统计
export const getDeviceCout = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/get_cout", data, config);
};
//批量删除设备
export const delBatch = (data = {}, config = {}) => {
    config.method = "del";
    return request(API_URL + "/sys/device/del_batch", data, config);
};
//批量设备绑定运营商
export const bindOperBatch = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/bind_oper_batch", data, config);
};
//批量设备解绑运营商
export const unbindOperBatch = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/unbind_oper_batch", data, config);
};
//根据运营商获取充电站
export const getStation = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/alarm/getStationByOpr", data, config);
};
//批量设备修改型号
export const upDevModel = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/upd_model_batch", data, config);
};
// 设备型号批量添加设备
export const pilesAddBatch = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/manage/add_batch", data, config);
};
// 获取设备型号标配或选配参数列表
export const getModelOptionsList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/model/options/list", data, config);
};
// 获取设备型号详情
export const deviceModelDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/model/detail", data, config);
};
//设备厂商下拉接口
export const getManufacturerList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/manufacturer/get", data, config);
};
//修改充电枪信息
export const chargeGunUpd = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/upd_charge_gun", data, config);
};
//下发费率--下发电价
export const sendSyncfeeRatecmd = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/opr/send_syncfee_ratecmd", data, config);
};
//解锁,下发二维码
export const sendPileOperation = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/opr/send_pile_operation", data, config);
};
// 查看用户已关联的站点
export const oprUserStaBound = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/user/sta/bound", data, config);
};
// 查看用户未关联的站点
export const oprUserStaUnbound = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/user/sta/unbound", data, config);
};
//关联站点
export const oprUserOperationSta = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/operation/sta", data, config);
};
//解绑站点
export const unbindSta = (data = {}, config = {}) => {
    // config.method = "postStr";
    return request(API_URL + "/sys/device/opr/dev_unbind_sta", data, config);
};
//充电桩列表 - 获取额定功率
export const getDevicePower = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/device/opr/power/list", data, config);
};
// 分页查询Sim卡
export const getSIMCardPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/page", data, config);
};
// 分页获取sim卡信息
export const getSIMCard = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sim/page", data, config);
};
// 获取sim卡统计数据
export const getSIMCardStatistics = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sim/statistics", data, config);
};
// 获取SIM详情
export const SIMCardDetail = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/detail", data, config);
};
// 新增SIM卡
export const SIMCardAdd = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/add", data, config);
};
// 修改SIM卡
export const SIMCardUpd = (data = {}, config = {}) => {
    return request(API_URL + "/sys/sim/update", data, config);
};
// 统计SIM卡数据
export const SIMTotal = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/sim/total/sim_gird", data, config);
};
// 导入SIM
export const SIMImport = (data = {}, config = {}) => {
    // config.method = "postStr";
    return request(API_URL + "/sys/sim/import/sim_gird", data, config);
};
// 查询模板文件信息
export const SIMTemplateSelect = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/template/select", data, config);
};
// 今日告警
export const getAlarmToday = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/today", data, config);
};
// 告警概览-汇总数据
export const getAlarmSummary = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/summary", data, config);
};
// 告警概览-汇总数据(过滤已读)
export const getAlarmSummaryFilter = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/static/filter", data, config);
};
//保存用户告警已读统计
export const getAlarmCountSave = (data = {}, config = {}) => {
    return request(API_URL + "/alarm/user/alarm/level/count/save", data, config);
};
// 充电站告警排名top
export const getAlarmStaTop5 = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/sta/top", data, config);
};
// 告警查询  /basic-system/v1/alarm/query
export const getAlarmQuerys = (data = {}, config = {}) => {
    return request(API_URL + "/alarm/query", data, config);
};
// 充电桩告警排名top
export const getAlarmPileTop5 = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/pile/top", data, config);
};
// 获取运营商的登录地址
export const getLoginUrl = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/opr/get_login_url", data, config);
};
// 获取运营商详情
export const getOprDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/opr/get", data, config);
};
//获取运营商移动端配置
export const getOperAppConfig = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/opr/app/config", data, config);
};
//修改运营商移动端配置
export const updataOperAppConfig = (data = {}, config = {}) => {
    return request(API_URL + "/sys/opr/upd_app_config", data, config);
};
// 获取车辆信息集合
export const getUserCarList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/user/car/list", data, config);
};
// 添加车辆信息
export const addUserCar = (data = {}, config = {}) => {
    return request(API_URL + "/user/car/add", data, config);
};
// 更新车辆信息
export const upUserCar = (data = {}, config = {}) => {
    return request(API_URL + "/user/car/upd", data, config);
};
// 删除车辆信息
export const delUserCar = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/user/car/del", data, config);
};
// 获取设备采集扩展属性列表
export const getExpandPropertyList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/manage/expand/property/list", data, config);
};
// 迁出充电桩
export const deviceQuit = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/quit", data, config);
};
// 导入个人会员
export const importUser = (data = {}, config = {}) => {
    config.method = "formData";
    config.timeout = 60 * 20 * 1000; // 设置超时时间
    return request(API_URL + "/user/import", data, config);
};
// 保存用户导入数据
export const saveImportUser = (data = {}, config = {}) => {
    config.timeout = 60 * 20 * 1000; // 设置超时时间
    return request(API_URL + "/user/import/save", data, config);
};
// 事件告警内容集合
export const getFaultAlarmAll = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/alarm/list/fault_alarm", data, config);
};
// 批量操作充电桩状态
export const batchUpdDeviceStatus = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/batch_upd_device_status", data, config);
};
// 批量操作充电桩所属电站
export const batchUpdChargePileSta = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/batch_upd_charge_pile_sta", data, config);
};
// 获取idemToken的接口
export const getAuthIdempotence = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/auth/idempotence", data, config);
};
// 获取车牌库列表
export const getUserCarPage = (data = {}, config = {}) => {
    return request(API_URL + "/user/car/page", data, config);
};
// 获取运营商通知列表（分页）
export const getNoticerPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/notice/opr/page", data, config);
};
// 获取运营商通知统计问题
export const getNoticerSummary = (data = {}, config = {}) => {
    return request(API_URL + "/sys/notice/summary", data, config);
};
// 已读运营商通知
export const readNoticer = (data = {}, config = {}) => {
    return request(API_URL + "/sys/notice/read", data, config);
};
// 分页获取绑定充电桩信息
export const getOprBindPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/bind/page", data, config);
};
// 设备批量解绑站点
export const unbindOprBindDevice = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/batch/dev_unbind_sta", data, config);
};
// 批量编辑查询列表
export const getDeviceGunPage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/gun_page", data, config);
};
// 批量编辑--导入充电枪信息
export const importDeviceGun = (data = {}, config = {}) => {
    config.method = "formData";
    return request(API_URL + "/sys/device/opr/import_gun", data, config);
};
// 批量编辑--提交修改充电枪信息
export const submitUpdataDeviceGun = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/upd_gun", data, config);
};
// 批量下发二维码
export const allBatchSendPileQrCode = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/batch_send_pile_qr_code", data, config);
};
// 批量校验二维码
export const allBatchCheckPileQrCode = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/batch_check_pile_qr_code", data, config);
};
// 批量校验费率
export const allBatchCheckPileFee = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/batch_check_pile_fee_rate", data, config);
};
// 分页查询二维码下发明细
export const getDeviceOprQrCodePage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/device/opr/qr_code_page", data, config);
};
// 分页查询设备报告档案
export const getDeviceArchivePage = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/archive/page", data, config);
};
// 分页获取日志记录
export const getArOperationLogPage = (data = {}, config = {}) => {
    return request(API_URL + "/ar/operation/log/page", data, config);
};
//获取注册用的省市区
export const getRegisterFindAreaList = (data = {}, config = {}) => {
    return request(API_URL + "/opr/info/register/findAreaList", data, config);
};
//运营商注册
export const oprInfoRegister = (data = {}, config = {}) => {
    return request(API_URL + "/opr/info/register", data, config);
};
//运营商省市区按id查询
export const getRegionFindAreaListByLevel = (data = {}, config = {}) => {
    return request(API_URL + "/region/findAreaList/by_level", data, config);
};
//重置密码验证参数
export const registerRetrievePsw = (data = {}, config = {}) => {
    return request(API_URL + "/opr/info/register/retrieve_psw", data, config);
};
//重置密码
export const registerResetPwd = (data = {}, config = {}) => {
    return request(API_URL + "/opr/info/register/reset_pwd", data, config);
};
//发送短信验证码
export const getVercodeSmsByOperatorId = (data = {}, config = {}) => {
    return request(API_URL + "/vercode/sms/by_operatorId", data, config);
};
//查询注册发送短信的运营商
export const getRegisterSmsopr = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/info/register/sms/config/get", data, config);
};
//根据媒体文件标识ID查询图片信息
export const getMediaIdFileUrl = (data = {}, config = {}) => {
    return request(API_URL + "/file/get_img", data, config);
};
//删除图片
export const deleteMediaIdFileUrl = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/file/delete_img", data, config);
};
// 导入设备文件生成列表数据
export const importDevice = (data = {}, config = {}) => {
    config.method = "formData";
    return request(API_URL + "/sys/device/manage/import", data, config);
};
// 批量添加充电桩
export const addBatchOprDevice = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/batch_add", data, config);
};
// 添加地锁
export const addFloorLock = (data = {}, config = {}) => {
    return request(API_URL + "/sys/floor/lock/add", data, config);
};
// 查询地锁
export const getFloorLock = (data = {}, config = {}) => {
    return request(API_URL + "/sys/floor/lock/query", data, config);
};
// 重置地锁
export const resetFloorLock = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/sys/floor/lock/reset", data, config);
};
// 配置地锁
export const configFloorLock = (data = {}, config = {}) => {
    return request(API_URL + "/sys/floor/lock/config", data, config);
};
// 获取地锁实时数据
export const getConfigFloorLockRd = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/sys/floor/lock/rd", data, config);
};
//分页获取操作日志数据
export const getOperationLogPage = (data, config = {}) => {
    return request(API_URL + "/charge/pile/operation/page", data, config);
};
//检验是否满足解绑条件
export const getValidateUnbind = (data, config = {}) => {
    return request(API_URL + "/sys/device/opr/validate_unbind", data, config);
};
//删除站点
export const getDeleteStation = (data, config = {}) => {
    config.method = "del";
    return request(API_URL + "/sys/device/opr/del_batch_charge_pile", data, config);
};
//站点管理资产概览-充电桩统计
export const getOprAssetStatisticsPile = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/pile/state/statistics", data, config);
};
//站点管理资产概览-充电桩功率统计
export const getOprAssetStatisticsPower = (data = {}, config = {}) => {
    return request(API_URL + "/sys/device/opr/pile/power/statistics", data, config);
};
//站点管理资产概览-SIM卡状态数据统计
export const getOprAssetStatisticsSim = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sim/status/statistics", data, config);
};
